import React from "react";
import InheritenceDisplay from "components/InheritenceDisplay";
import { useFormikContext } from "formik";
import { STATE_KEYS } from "utils/constants/state";
import startCase from "lodash/startCase";

const TaxIdCollectionSummary = ({ type, active, error }) => {
  const { setFieldValue } = useFormikContext();
  const copy = active ? (type ? startCase(type) : "No type") : "Disabled";

  return (
    <InheritenceDisplay
      title="Tax id collection"
      error={error}
      onRemove={() => {
        setFieldValue(STATE_KEYS.SHORT_LINK.TAX_ID_COLLECTION_ENABLED, false);
        setFieldValue(STATE_KEYS.SHORT_LINK.TAX_ID_COLLECTION_TYPE, false);
      }}
    >
      <div className="flex flex-row justify-between items-center">
        <div className="f6 word-break pr1">{copy}</div>
      </div>
    </InheritenceDisplay>
  );
};

export default TaxIdCollectionSummary;
